import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as stagesActions from '../../../actions/stages';
import AdminItemPageContainer from '../admin-item-page-container';
import StageResultsForm from '../../../components/stage/stage-results-form';
import LocalizedStrings from '../../../localization/strings';

class StageResultsContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/stages';
    }

    onSuccessSubmit() {
        // alert('Saved');
    }

    fetchItem(id) {
        return this.props.actions.fetchStage(id)
    }

    render() {
        return (
            <div className="panel">
                <header className="panel-header">{LocalizedStrings.stageResults}</header>
                <div className="panel-body">
                    <StageResultsForm submit={(values) => {
                        return this.props.actions.submitStageResults(this.props.params.itemId, values)
                    }} onSuccessSubmit={this.onSuccessSubmit.bind(this)}/>
                </div>
            </div>

        )
    }
}

export default connect(function(state) {
    return {loading: state.stage.stage.loading, stage: state.stage.stage.item};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...stagesActions
        }, dispatch)
    };
})(StageResultsContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/stage/stage-results-container.js